import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const SettingsIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path
        d="M15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12Z"
        stroke="currentColor"
      />
      <path
        d="M9.77208 2.68377L9 5L7.44016 5.98656L4.88796 5.35506C4.46009 5.2492 4.01337 5.43595 3.78816 5.81484L2.42396 8.10993C2.17813 8.52353 2.26167 9.05356 2.62281 9.37147L4.41294 10.9474V13.0526L2.62337 14.6285C2.26231 14.9464 2.17882 15.4764 2.42463 15.8899L3.78888 18.1851C4.01409 18.564 4.46082 18.7508 4.88868 18.6449L7.44089 18.0134L8.91858 18.8421L9.62394 21.2781C9.74775 21.7057 10.1393 22 10.5845 22H13.4163C13.8614 22 14.253 21.7057 14.3768 21.2781L15.0822 18.8421L16.5591 18.0134L19.1113 18.6449C19.5392 18.7508 19.9859 18.564 20.2111 18.1851L21.6011 15.8466C21.8352 15.4528 21.7717 14.9502 21.4471 14.627L19.6409 12.8287L19.6416 11.1713L21.4478 9.37298C21.7725 9.04974 21.836 8.54721 21.6019 8.15339L20.2118 5.81484C19.9866 5.43595 19.5399 5.2492 19.112 5.35506L16.5598 5.98656L15 5L14.2279 2.68377C14.0918 2.27543 13.7097 2 13.2792 2H10.7208C10.2903 2 9.90819 2.27543 9.77208 2.68377Z"
        stroke="currentColor"
      />
    </SvgIcon>
  )
}
